export const GLOBAL_SUPPORT_EMAIL = "hello@blocklayerhq.com?Subject=Support"
